<div class="w-full text-left">
  <app-manual-hero
    eyebrow="City Parking"
    title="ศูนย์ช่วยเหลือ"
    subtitle="เลือกคู่มือการใช้งาน หรือแจ้งปัญหาติดต่อบริษัท"
    icon="/icons/help_slate_dark.svg"
  ></app-manual-hero>

  <div class="relative z-10 -mt-7 space-y-5">
    <!-- Guides -->
    <section aria-label="คู่มือการใช้งาน">
      <div class="grid grid-cols-2 gap-3">
        <a
          routerLink="/manual/guides/parking"
          class="guide-tile bg-white rounded-2xl p-4 flex flex-col gap-3 no-underline text-inherit border border-amber-100"
        >
          <div class="flex items-center justify-between">
            <div class="w-12 h-12 rounded-2xl bg-(--main-color) flex items-center justify-center">
              <img src="/icons/local_parking_black.svg" alt="" class="w-7 h-7" />
            </div>
            <img src="/icons/chevron_right_slate.svg" alt="" class="w-5 h-5 opacity-50" />
          </div>
          <div>
            <p class="text-sm font-extrabold text-slate-800 m-0">คู่มือ Parking</p>
            <p class="text-[11px] text-slate-500 font-medium leading-snug m-0 mt-1">
              วิธีใช้ระบบลานจอดรถ / บัตรสมาชิก
            </p>
          </div>
        </a>

        <a
          routerLink="/manual/guides/ev"
          class="guide-tile bg-white rounded-2xl p-4 flex flex-col gap-3 no-underline text-inherit border border-slate-100"
        >
          <div class="flex items-center justify-between">
            <div class="w-12 h-12 rounded-2xl bg-amber-50 border border-amber-100 flex items-center justify-center">
              <img src="/icons/ev_station_slate_dark.svg" alt="" class="w-7 h-7" />
            </div>
            <img src="/icons/chevron_right_slate.svg" alt="" class="w-5 h-5 opacity-50" />
          </div>
          <div>
            <p class="text-sm font-extrabold text-slate-800 m-0">คู่มือ EV Charger</p>
            <p class="text-[11px] text-slate-500 font-medium leading-snug m-0 mt-1">
              วิธีใช้ระบบชาร์จรถยนต์ไฟฟ้า
            </p>
          </div>
        </a>
      </div>
    </section>

    <!-- Contact -->
    <section>
      <h3 class="text-xs font-extrabold text-gray-500 uppercase tracking-wide mb-2.5 px-1 m-0">ติดต่อเรา</h3>
      <a
        routerLink="/manual/report"
        class="contact-card rounded-2xl p-4 flex items-center gap-3 no-underline relative overflow-hidden"
      >
        <div class="absolute -right-6 -bottom-8 w-24 h-24 rounded-full bg-[rgba(255,197,39,0.12)] pointer-events-none"></div>
        <div class="w-12 h-12 rounded-2xl bg-white/10 flex items-center justify-center shrink-0 relative">
          <img src="/icons/contact_support_orange.svg" alt="" class="w-7 h-7" />
        </div>
        <div class="min-w-0 flex-1 relative">
          <p class="text-sm font-extrabold text-white m-0">แจ้งปัญหา / ติดต่อบริษัท</p>
          <p class="text-[11px] text-white/65 font-medium m-0 mt-0.5">ที่อยู่บริษัท และเบอร์ติดต่อ</p>
        </div>
        <div class="w-8 h-8 rounded-full bg-(--main-color) flex items-center justify-center shrink-0 relative">
          <img src="/icons/chevron_right_black.svg" alt="" class="w-5 h-5" />
        </div>
      </a>
    </section>
  </div>
</div>
